import Env from '../../base/env';
import Channels from '../../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap'
import { SlowMo } from '../../vendor/gsap-bonus-umd/EasePack'
gsap.registerPlugin(SlowMo);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.loopItems = this.DOM.view.querySelectorAll('.js-item')
    this.DOM.loopItemsAll = this.DOM.view.querySelectorAll('.js-item-all')
    this.DOM.getLast = this.DOM.loopItems[this.DOM.loopItems.length - 1]
    this.DOM.getLastAll = this.DOM.loopItemsAll[this.DOM.loopItemsAll.length - 1]
    //! VARS
    this.INVERT = (typeof this.DOM.view.getAttribute('data-invert') != 'undefined' && this.DOM.view.getAttribute('data-invert') == 1)?true:false;
    this.RAF = false
    this.MOVING_X = 0
    this.SPEED = (Env.mobileCSS)?.2:1
    if(this.DOM.view.getAttribute('data-speed') != null) {
      this.SPEED = this.DOM.view.getAttribute('data-speed') * 1
    }
    this.SCROLL_SPEED = 0
    this.CAN_START = false
    //! FNs
    setTimeout(() => {
      this.funcResize = this.resize.bind(this)
      this.funcStart = this.start.bind(this)
      Channels.on('window::smartresize',this.funcResize)
      Channels.on('cover::finalize',this.funcStart)
      this.resize()
      this.watcher()
    }, 1000);

  }

  resize()
  {
    const viewport = Env.framework.toolbox.getViewport()
    this.COORDS = this.DOM.getLast.getBoundingClientRect()
    this.MOVE_X_LIMIT = (this.COORDS.width + this.COORDS.x) * -1
    // this.MOVE_X_LIMIT = ((this.COORDS.width + this.COORDS.x) - viewport.width) * -1
  }

  start()
  {
    this.CAN_START = true
    console.log('can start');
  }

  watcher() {
    this.RAF = requestAnimationFrame(()=>{

      //? get scroll speed
      if(typeof Env.smoothInstance != 'undefined') {
        this.SCROLL_SPEED = Env.smoothInstance.getVelocity() / 200
      }
      let currentSpeed = this.SPEED + Math.abs(this.SCROLL_SPEED)

      //? set direction
      if(typeof Env.smoothInstance != 'undefined' && typeof Env.smoothInstance.scrollTrigger.direction != 'undefined') {
        if(Env.smoothInstance.scrollTrigger.direction == 1) {
          if(this.INVERT == true) {
            this.MOVING_X+= currentSpeed
          } else {
            this.MOVING_X-= currentSpeed
          }
        } else {
          if(this.INVERT == true) {
            this.MOVING_X-= currentSpeed
          } else {
            this.MOVING_X+= currentSpeed
          }
        }
      } else {
        if(this.INVERT == true) {
          this.MOVING_X+= currentSpeed
        } else {
          this.MOVING_X-= currentSpeed
        }
      }

      //? set limit
      // this.MOVING_X = this.MOVING_X % this.MOVE_X_LIMIT
      if(this.MOVING_X <= this.MOVE_X_LIMIT) {
        this.MOVING_X = 0
      } else if(this.MOVING_X >= 0) {
        this.MOVING_X = this.MOVE_X_LIMIT
      }

      //? set tween
      gsap.set(this.DOM.loopItemsAll, { x: this.MOVING_X })


      //? render
      this.watcher()
    })
  }


  unmount()
  {
    Channels.removeListener('window::smartresize',this.funcResize)
    Channels.removeListener('cover::finalize',this.funcStart)
    cancelAnimationFrame(this.RAF)
  }
}
